enum CuePosition {
    DEFAULT
}

export default CuePosition;